<!--
@Description: 直播趋势
@Author: 吳廣帥
@Date:2022/1/5 - 13:40
@Name:lineChart
@Version:v1.0
-->
<style scoped lang="less">
/** 最外层div盒子*/
.trend-box {
  margin-top: .22rem;
  padding: .24rem;
}
.chart{
  margin-top: .24rem;
  width: 7rem;
  height: 3.5rem;
}
</style>
<template>
  <!--  组件最外层盒子-->
  <div class="trend-box">
    <ButtonGroup :button-group="buttonGroup" label="开播趋势" v-model="chartType"/>
      <template v-if="isVip">
        <div v-show="showChart" ref="chart" class="chart"/>
        <none-data :height="3.5" v-show="!showChart" class="chart"/>
      </template>
      <Blur-image v-else vipText="升级会员，即可查看" class="chart"/>
  </div>
</template>
<script>
import ButtonGroup from './buttonGroup'
import moment from "moment";
import {dateLongDuration} from "@/plugins/helper";
export default {
  /** 组件区 **/
  components: { ButtonGroup },
  /** 方法区 **/
  methods: {
    formatDuration(unix) {
      const hours = parseInt(unix / 3600)
      const minutes = parseInt(unix / 60) % 60
      return hours ? `${hours}小时${minutes}分钟` : minutes + '分钟'
    },
    drawChart(){
      if(!this.showChart) return
      echarts.init(this.$refs.chart).setOption({
        tooltip: {
          trigger: 'item',
          formatter: params => {
            const date = `<div>日期 <span class="din" style="float: right">${params.name}</span></div>`
            if( this.chartType === 'duration'){
              return(`${date}<div>累计时长 <span style="margin-left: .24rem">${this.formatDuration(params.value)}</span></div>`)
            }else{
              return(`${date}<div>开播场次 <span style="margin-left: .24rem">${params.value}</span></div>`)
            }
          }
        },
        grid: {
          left: this.chartType === 'duration'? 45 : 20,
          top: 10,
          bottom: 20,
          right:25,
        },
        xAxis: [{
          type: 'category',
          data: this.chartData.x,
          axisLabel: { textStyle: { color: '#848f9c' } },
          axisLine: { lineStyle: { color: '#848f9c' } },
          axisTick: { color: '#848f9c' },
        }],
        yAxis: [
          {
            type: 'value',
            axisLabel: { formatter: val => this.chartType === 'duration' ?   val / 3600 + '小时' : val , color: '#848F9C' },
            interval: this.chartType === 'duration'? 10800 :  1
          },
        ],
        series: [{
          smooth: true,
          type: 'bar',
          data: this.chartData.y,
          symbol: 'path://M511.928873 69.657937c-244.140632 0-442.345355 198.204723-442.345355 442.346673 0 244.134047 198.204723 442.336135 442.345355 442.336135 244.136681 0 442.337452-198.203406 442.337453-442.336135 0-244.140632-198.200772-442.346673-442.337453-442.346673z', //设定为实心点
          symbolSize: 10,
          barMaxWidth: 40,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [{ offset: 0, color: '#2A89F4' }, { offset: 1, color: 'rgba(42,137,244,0.5)' }]
            )
          },
        }]
      })
    }
  },
  watch: {
    chartData:{
      immediate:true,
      deep:true,
      handler(){
        this.drawChart()
      }
    },

  },
  /** 数据区 **/
  props: {
    propData:{ type:Object,default:() => ({}) }
  },
  computed: {
    showChart: (_this = this) => _this.chartData.x.length && _this.chartData.y.length && !!_this.chartData.y.reduce( (total,ele) => total += ele || 0,0),
    isVip: (_this = this) => true,
    chartData: (_this = this) => ({
      x:_this.$props.propData.x ?  _this.$props.propData.x.map( ele => moment(ele).format('MM-DD') ) : [],
      y:_this.$props.propData.y ? _this.$props.propData.y.map( ele => ele[_this.chartType] || 0) : [],
    })
  },
  data() {
    return {
      buttonGroup:[{ label:'直播时长', key:'duration' }, { label:'开播场次', key:'liveAmount'}],
      chartType:'duration'
    }
  },
}
</script>








